import {
  LOAD_MAP_INITIAL_STATE,
  LocationMapActions,
  RENDER_MAP_ACTION,
} from '../../actions/location-map-actions/location-map.actions';
import { CmxMapConfig } from '../../../../../shared/models/cmx-map-config/cmx-map-config';

export interface ILocationMapState {
  /**
   * Either renders the map or not
   */
  showMap: boolean;
  /**
   * A configuration structure for the map itself
   */
  config: CmxMapConfig;
}

export const initialState: ILocationMapState = {
  showMap: false,
  config: new CmxMapConfig(null),
};

export function locationMapReducer(state = initialState, action: LocationMapActions): ILocationMapState {
  switch (action.type) {
    case LOAD_MAP_INITIAL_STATE: {
      return action.payload;
    }
    case RENDER_MAP_ACTION: {
      return {
        showMap: true,
        config: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
